const company = process.env.REACT_APP_TITLE || 'LeCab';

export default {
    admin: {
        owner: 'Propriétaire',
        import: 'Importer',
        adminOf: 'Administrateur de',
        groupAdmin: 'Vous êtes l’administrateur',
        payment: {
            paymentTitle: 'Moyens de paiement',
            policiesTitle: 'Politiques de paiement',
            policyLabel: 'Politique de paiement',
            paymentMethodsDesc: `Vous pouvez ajouter les moyens de paiement utilisés pour les réservations de vos collaborateurs.`,
            blueCardTitle: 'Paiement en carte bleue',
            airplusTitle: 'Paiement par carte AirPlus',
            wireTransfer: 'Paiement en virement',
            onBoardPayment: 'Paiement à bord',
            sepa: 'Paiement SEPA',
            noBlueCard: 'Vous n’avez aucune carte bleue associée.',
            noAirplusCard: 'Vous n’avez aucune carte AirPlus associée.',
            howToAddSepaAirplus:
                'Pour ajouter une carte AirPlus ou Paiement SEPA, veuillez contacter notre service client. Vous pouvez aussi opter pour le moyen de paiement par virement via le RIB présent sur vos factures mensuelles.',
            defaultPaymentPerGroup: 'Moyen de paiement par défaut pour les courses',
            configureDefaultPaymentPerGroup: 'Configurez vos moyens de paiement par défaut pour chacun de vos groupes.',
            centralized: 'Centralisé',
            individual: 'Individuelle',
            partial: 'Paiement Partiel - avec Reste à charge',
            monthly: 'Mensuel',
            unitary: 'À la course',
            groupPaymentPolicyTitle: 'Politique de paiement du groupe',
            groupPaymentPolicyDesc: `Vous pouvez modifier la politique de paiement de votre groupe via la section "Paiement" du menu administrateur.`,
            subtitle: 'Personnalisez les options de paiement de vos collaborateurs.',
            frequencyPayment: 'Fréquence de paiement',
            paymentCoworkerError:
                'Le passager n’a pas de moyen de paiement défini dans son profil, vous ne pouvez pas lui réserver de course sur ce groupe.',
            paymentGroupError: 'Aucun moyen de paiement n’est définie pour ce groupe. Contactez votre administrateur.',
            voucher: {
                title: 'Prises en charge',
                description:
                    'Créez vos type de prise en charge partielle ici, et associez-les à vos groupes dans l’onglet “Politiques de paiement”',
                empty: 'Aucune prise en charge sur ce moyen de paiement.',
                add: 'Ajouter un type de prise en charge',
                edit: 'Modifier le type de prise en charge',
                deleteHint: 'Êtes-vous sûr de vouloir supprimer la prise en charge : {{details}} ?',
                form: {
                    name: 'Nom',
                    amount: 'Montant',
                    format: 'Format',
                    amountUnit: '€',
                    percentageUnit: '%',
                    duplicateName: 'Une prise en charge porte déjà ce nom.',
                    invalidAmount: 'Le montant doit être supérieur à 0.',
                    invalidPercentage: 'Le pourcentage doit être compris entre 1 et 100.',
                },
                select: {
                    label: 'Prise en charge',
                    option: '{{name}} — {{value}}',
                    empty: 'Aucune prise en charge disponible, créez-en une.',
                    emptyAskContractAdmin: 'Aucune prise en charge disponible. Contactez l’administrateur du contrat.',
                },
                errors: {
                    inUse: 'Cette prise en charge est utilisée par la politique de paiement d’un groupe. Retirez-la du groupe avant de la supprimer.',
                },
            },
        },
        roles: {
            booker: 'Réserver',
            rider: 'Voyager',
            principal: 'Administrateur',
        },
        importBulk: {
            title: 'Importer des collaborateurs',
            descFirstPart:
                'Ajoutez plusieurs collaborateurs d’un coup à ce groupe en important une feuille de calcul. Pour commencer',
            descFirstPartCta: ' Téléchargez et remplissez ce modèle.',
            descSecondPartInvite:
                'Une invitation à rejoindre ce groupe leur sera envoyée par mail. Vous pourrez modifier leur rôle au sein de ce groupe par la suite.',
            descSecondPart: 'Vous pourrez modifier leur rôle au sein de ce groupe par la suite.',
            descThirdPartFirstLine: 'CSV, XLSX feuilles de calcul acceptées.',
            descThirdPartSecondLine: 'Format de colonne : nom, prénom, email, téléphone (optionnel).',
        },
        users: {
            associate: 'Ajouter',
            nbCollabAssociatedSingular: 'collaborateur est présent dans ce groupe.',
            nbCollabAssociatedPlural: 'collaborateurs sont présents dans ce groupe.',
            addCollab: 'Ajouter un collaborateur',
            inviteCollab: 'Inviter un collaborateur',
            addCollabDesc:
                'Veuillez sélectionner le groupe dans lequel vous souhaitez importer de nouveaux collaborateurs.',
            addNewCollab: 'Ajouter un nouveau collaborateur',
            inviteNewCollab: 'Inviter un nouveau collaborateur',
            handleCollab: 'Gérer les collaborateurs',
            handleCollabVariant: 'Gérer des collaborateurs',
            bulkActionDesc: 'Bulk Action (Rôle + Supprimer)',
            fillFormCollab: 'Remplissez le formulaire pour ajouter un collaborateur.',
            fillFormCollabInvite: 'Remplissez le formulaire pour inviter un collaborateur.',
            addMultipleCollab: 'Ajouter plusieurs nouveaux collaborateurs',
            inviteMultipleCollab: 'Inviter plusieurs nouveaux collaborateurs',
            importCollabWithSheet: 'Ajoutez des collaborateurs en important une feuille de calcul.',
            importCollabWithSheetInvite: 'Invitez des collaborateurs en important une feuille de calcul.',
            linkCollab: 'Ajouter des collaborateurs existants',
            selectCollab: 'Sélectionnez des collaborateurs à ajouter à ce groupe',
            addCollabs: 'Ajouter des collaborateurs',
            ungroup: 'Supprimer',
            invitePending: 'Invitation en attente',
            invitePendingSince:
                'Le collaborateur a été ajouté le {{date}} mais ne semble toujours pas avoir accepté son invitation par email.',
            invitePendingResend: 'Relancer l’invitation par email.',
            inviteSent: 'Invitation envoyée',
            editCollab: 'Modifier un collaborateur',
            collabGroups: 'Groupe du collaborateur',
            collabGroupsDesc: 'Vous pouvez importer un fichier contenant les collaborateurs à ajouter au groupe.',
            collabGroupsDescInvite: 'Vous pouvez importer un fichier contenant les collaborateurs à inviter au groupe.',
            collabLinkGroup: 'Ajouter à un nouveau groupe',
            collabUnlinkGroup: 'Supprimer',
            collabUnlinkLastGroup:
                'Êtes-vous sûr de vouloir supprimer ce collaborateur ? Il appartient uniquement à ce groupe et sera donc supprimé de vos collaborateurs si vous le supprimez de son dernier groupe.',
            collabUnlinkGroupDesc: 'Êtes-vous sûr de vouloir supprimer ce collaborateur du groupe "{{group}}" ?',
            deleteCollab: 'Supprimer le collaborateur',
            collabAdded: 'Collaborateur ajouté',
            collabDeleted: 'Collaborateur supprimé',
            deletePopupDesc:
                'Êtes-vous sûr de vouloir supprimer le collaborateur "{{user}}" ? Cette action est irréversible.',
            deleteCollabDesc: 'Vous pouvez supprimer le collaborateur de votre entreprise.',
            noCollabResult: 'Vous n’avez actuellement aucun collaborateur correspondant à votre recherche.',
        },
        groups: {
            group: 'Groupe',
            groups: 'Groupes',
            addGroup: 'Ajouter un groupe',
            delGroup: 'Supprimer le groupe',
            delGroupToast: 'Groupe supprimé.',
            delGroupDesc:
                'Vous pouvez supprimer ce groupe. Les collaborateurs ajoutés à celui-ci seront alors supprimés.',
            delGroupConfirmation: 'Êtes-vous sûr de vouloir supprimer ce groupe et tous ses membres ?',
            travelPolicyTitle: 'Politiques voyages',
            travelPolicyCautionPartOne: 'Vous pouvez éditer les politiques voyages de ce groupe.',
            travelPolicyCautionPartTwo: 'Attention, celles-ci seront appliquées dès votre prochaine réservation.',
            addGroupHint: 'Vous devez être administrateur du contrat pour créer un groupe',
            travelPolicy: 'Politiques voyage du groupe',
            travelPolicyDescriptionFirstPart: 'Paramétrez les politiques de voyages à appliquer à votre groupe ',
            travelPolicyDescriptionSecondPart:
                "afin de personnaliser l'expérience de réservation et de voyage de vos collaborateurs.",
            groupName: 'Nom du groupe',
            editGroupName: 'Modifier le nom du groupe',
            addGroupDescription:
                "Nommez votre nouveau groupe afin de pouvoir lui attribuer de nouvelles politiques voyages à l'étape suivante.",
            editGroup: 'Modifier un groupe',
            editGroupAddCollabTitle: 'Ajouter/modifier des collaborateurs',
            editGroupAddExistingCollabDesc:
                'Sélectionner des collaborateurs à ajouter à votre groupe "{{group}}". Ils seront dissociés de leur groupe actuel.',
            editGroupAddCollabDesc: 'Ajoutez de nouveaux collaborateurs, modifiez leur(s) rôle(s) ou supprimez les.',
            editGroupMessage:
                'Vous pourrez éditer les informations de chaque groupe, inviter des collaborateurs à les rejoindre et accéder à leurs politiques de voyages.',
        },
        billing: {
            formula: {
                title: 'Abonnement',
                dueDate: 'Montant dû pour le ',
                currencyPerMonth: '€/mois TTC',
                user: 'utilisateur',
                maxUsers: 'Max. {{maxUsers}} utilisateurs',
                unlimited: 'Illimités',
                additionalUsers: {
                    title: 'Hors forfait',
                    collab: 'collaborateur(s)',
                    guest: 'invité(s)',
                },
                changeOffer: {
                    title: 'Changer d’offre',
                    label: 'Vous pouvez changez d’offre à tout moment.',
                },
                chart: {
                    nbUsers: 'Nombre d’utilisateurs',
                    formula: 'Offre active',
                },
                terminate: 'Je souhaite résilier mon abonnement',
            },
            invoices: {
                title: 'Factures',
                invoices: 'Vos factures',
                downloadReport: 'Télécharger le rapport',
                description: 'Vous trouverez ici la liste des factures de vos groupes.',
                noInvoices: 'Vous n’avez actuellement aucune facture émise.',
                noInvoicesResult: 'Vous n’avez actuellement aucune facture émise correspondant à votre recherche.',
                type: {
                    title: 'Type de facture',
                    ride: 'Facture course',
                    month: 'Facture mensuelle',
                    subscription: 'Abonnement',
                    correction: 'Facture',
                    exceptional: 'Facture',
                },
            },
            settings: {
                title: 'Paramètres',
                address: {
                    title: 'Adresse de facturation',
                    name: 'Nom de facturation',
                    address: 'Adresse',
                    postalCode: 'Code postal',
                    city: 'Ville',
                    country: 'Pays',
                },
                contact: {
                    title: 'Contact financier',
                    description:
                        'Ajoutez un ou plusieurs contact(s) financier(s). Ils recevront les factures par email.',
                    add: 'Ajouter un contact financier',
                    edit: 'Modifier un contact financier',
                },
                params: {
                    title: 'Paramètres de facturation',
                    description: 'TODO',
                    commandNumber: 'Bon de commande',
                    vta: 'N° de TVA',
                    xls: 'Factures XLS',
                    group: 'Factures par groupe',
                    termination: 'Résiliation',
                    terminationDescription:
                        "Pour résilier vos services, veuillez nous informer par e-mail à l'adresse resiliation@lecab.fr. Nous traiterons votre demande dans les plus brefs délais.",
                },
            },
        },
    },
    addressType: {
        airports: 'Aéroports',
        airportLabel: 'Aéroport',
        airportDescription: 'Voir les aéroports les plus proches',
        stations: 'Gares',
        stationLabel: 'Gare ferroviaire',
        stationDescription: 'Voir les gares les plus proches',
        favorites: 'Favoris',
        favoritesDescription: 'Voir vos favoris',
    },
    geolocation: {
        current: 'Ma position actuelle',
        noLocation:
            'Vous avez refusé l’accès à la localisation. Pour l’activer, accédez aux paramètres de votre navigateur.',
        noLocationMobile:
            'Vous avez refusé l’accès à la localisation. Pour l’activer, rendez-vous dans les paramètres de votre appareil.',
    },
    booking: {
        number: 'N° de course : {{number}}',
        details: 'Détails',
        seeDetails: 'Voir les détails',
        moreDetails: 'Plus de détails',
        passengerInfos: 'Informations Passager',
        reservationInfos: 'Informations de réservation',
        driverInfos: 'Informations chauffeur',
        reactiveFlow: 'Cliquez ici pour continuer votre réservation',
        soonRides: '{{count}} course(s) en cours',
        allRides: 'Voir toutes les courses en cours',
        policiesNoRide: 'Impossible de réserver',
        limitTime: 'Limite de réservation atteinte',
        limitTimeDesc: 'La réservation pour le {{dayHour}}, n’est pas autorisée sur le groupe {{group}}. ',
        limitGeo: "Limite de zone d'autorisation",
        limitGeoDesc:
            "Vous ne pouvez effectuer des réservations qu'entre les zones d'autorisations définies par votre entreprise.",
        contactAdmin: "Pour plus d'informations, veuillez contacter l'administrateur de votre groupe.",
        modalCancelAirportTitle: 'Quitter',
        modalCancelAirportBody: 'Êtes-vous sûr de vouloir quitter le parcours de réservation aéroport ?',
        modalCancelStationBody: 'Êtes-vous sûr de vouloir quitter le parcours de réservation train ?',
        noPoiOther: 'Passer cette étape',
        noPoiAirport: 'Je ne pars pas d’un terminal',
        noPoiStation: 'Je ne pars pas de la gare',
        noPoiBody: 'Votre chauffeur viendra vous chercher à l’adresse suivante : {{address}}',
        checkedBaggage: 'Bagage Soute',
        inPlaneBaggage: 'Bagage Cabine',
        plannedFlightArrivalDate: 'Arrivée du vol prévue le ',
        askingLuggageType: 'Quel type de bagage aurez-vous ?',
        adviseLuggageTime:
            "Afin de passer les différents contrôles et de récupérer vos bagages en toute sérénité, nous vous conseillons de programmer le départ de votre course à l'heure suivante :",
        askingOrderTime: 'À quelle heure souhaitez-vous programmer votre course ?',
        cancelResa: 'Annuler ma réservation',
        cancelRideConfirm:
            'Êtes-vous sûr de vouloir annuler votre réservation ? Des frais d’annulation pourront vous être facturés.',
        cancelRideFees: 'Des frais pourront vous être facturés.',
        cancelRideReason: 'Merci de préciser la raison de votre annulation :',
        cancelRideDone: 'Votre course a bien été annulée.',
        cancelRideWithCharge: {
            title: 'Suite à votre annulation',
            description: 'Votre chauffeur étant déjà en chemin, des frais d’annulation vous seront débité.',
            info: 'Notre équipe de régulation va contacter votre chauffeur pour mieux comprendre cette situation.',
        },
        noFees: 'Vous ne serez pas débité.',
        order: 'Commander',
        orderRide: 'Nous commandons votre course',
        etaHelper: 'Dans ',
        seats: ' places',
        seat: ' place',
        luggages: ' bagages',
        luggage: ' bagage',
        landingTime: "Heure d'atterrissage",
        euroCurrency: ' €',
        edit: 'Modifier',
        send: 'Envoyer',
        valid: 'OK',
        headerSetDestination: 'Où allez-vous ?',
        headerHello: 'Bonjour ',
        headerHelloResponsive: 'Bonjour {{name}} 👋',
        currentPosition: 'Position actuelle',
        searchAddress: 'Rechercher une adresse',
        pickup: 'Prise en charge',
        dropOff: 'Destination',
        scheduleBooking: 'Planifier ma course',
        date: 'Date',
        dateTooEarly: 'L’heure de votre réservation doit être dans au moins {{X}} min',
        dateTooEarlyPlane:
            "L’heure de votre réservation doit être dans au moins {{X}} min et après l'heure d'atterrissage de votre avion.",
        dateTooFuture: 'Le rendez-vous doit être prévu entre 30 minutes et 1 an après la réservation.',
        mad: 'Mise à disposition',
        madShort: 'MAD',
        madShortDescription: 'Pour une durée souhaitée',
        selectMad: "Sélectionner une durée de mise à disposition d'un chauffeur.",
        modifyMad: 'Modifier la durée de mise à disposition',
        madDescription: 'Vous réservez votre chauffeur pour <b>{{X}} heure(s)</b>.',
        madPeriod: 'Durée',
        madFreeRide: 'Durée libre',
        freeRide: 'Course libre',
        freeRidePrice: 'Prix calculé en fin de course',
        freeRideDescription: 'Vous réservez votre chauffeur pour <b>une course libre</b>',
        manageFavorites: 'Gérer vos favoris',
        noFavorite: "Vous n'avez aucun favori.",
        selectService: 'Sélectionner votre service',
        rideCapacityMax: ' personne(s) maximum',
        voucher: {
            label: 'Sélectionnez le type de prise en charge',
            select: 'Type de prise en charge',
            price: {
                covered: 'Prise en charge',
                remaining: 'Reste à charge',
                total: 'Montant total',
            },
        },
        voucherCoverage: {
            applied: 'Prise en charge de {{amount}} appliquée',
        },
        voucherV2: {
            label: 'Saisissez le montant de prise en charge',
            placeholder: 'Montant de la prise en charge',
            hint: "Le reste à charge sera calculé à l'étape suivante",
            confirm: 'Confirmez votre demande',
            price: {
                covered: 'Prise en charge',
                remaining: 'Reste à charge',
                totalAmout: 'Montant total',
                total: 'Total',
            },
        },
        select: 'Sélectionner',
        passengersTitle: 'Qui voyage sur cette course ?',
        selectPassengers: 'Vos derniers passagers',
        noPassengers: 'Aucun passager',
        addProPassenger: 'Ajouter un invité',
        searchPassengerGeneric: 'Rechercher par nom, numéro de téléphone ou email',
        searchPassengerGenericShort: 'Nom, téléphone ou email',
        searchPassengerCoworker: 'Rechercher un collègue',
        searchPassengerGuest: 'Rechercher un invité',
        searchPassengerCoworkerOrGuest: 'Rechercher un collègue ou un invité',
        searchRecent: 'Vos recherches récentes',
        addProPassengerDescription:
            'Ajoutez les informations personnelles de votre invité afin de lui réserver une course',
        phoneHint: 'Renseignez un numéro de téléphone portable afin de recevoir les SMS de suivi de course',
        bookForOther: "Réserver pour quelqu'un",
        searchInList: 'Rechercher dans la liste',
        paymentInfo: 'Information de paiement',
        paymentTitle: 'Vos moyens de paiement',
        paymentCentralized:
            'Tous vos coûts sont gérés par votre entreprise, qui utilise le <b>Paiement centralisé</b>. Vous ne pouvez donc pas modifier vos moyens de paiement.',
        paymentRacCoverage:
            'Votre entreprise prend en charge une partie du prix de vos courses. Le <b>reste à charge</b> sera pris en compte au moment du paiement.',
        selectPayment: 'Sélectionnez un moyen de paiement',
        cardMask: '•••• ',
        cardExpired: 'Carte expirée',
        cardNone: 'Aucune carte',
        planeTitle: 'Concernant votre vol',
        planeFailFetchData:
            "Désolé, nous n'avons pas pu retrouver les informations temps réel de votre vol. Veuillez tout de même vous assurer que les informations suivantes sont correctes.",
        planeConfirm: 'Pouvez-vous confirmer que ces informations sont correctes ?',
        planePlaceholder: 'Numéro de vol',
        planeExemple: '(ex: AF1234)',
        planeNoNumber: 'Poursuivre sans numéro de vol',
        planeNoNumberDesc: 'Si vous souhaitez un départ immédiat, vous pouvez ignorer les deux premiers champs.',
        planeTerminal: 'Terminal',
        planeInfo:
            "Renseignez votre date d'arrivée ainsi que votre numéro de vol afin de profiter du décalage automatique de l'heure de votre course en cas de retard de votre vol.",
        planeDetails:
            'Veuillez nous communiquer votre numéro de vol afin de vous assister en cas de retard ou de changement de vol.',
        planeAdviseFlightNumber:
            'Nous vous conseillons de renseigner votre numéro de vol afin de profiter du décalage automatique de votre course en cas de retard de votre vol.',
        trainTitle: 'Concernant votre train',
        trainPlaceholder: 'Numéro de train',
        trainDetails:
            "Renseignez votre numéro de train afin de profiter du décalage automatique de l'heure de votre course en cas de retard de votre train",
        meetingPoint: 'Zone de prise en charge',
        meetingPointEdit: 'Modifier zone de prise en charge',
        meetingPointName: 'Zone de prise en charge',
        meetingPointDetails:
            'Sélectionnez votre zone de prise en charge afin de faciliter la rencontre avec votre chauffeur',
        meetingPointRecap: 'Point de rendez-vous',
        stationDetails: 'Ajoutez votre numéro de train afin de faciliter la rencontre avec votre chauffeur',
        nameboard: {
            title: 'Facilitez votre prise en charge',
            label: 'Profitez d’un accueil personnalisé',
            hint1: 'Votre chauffeur vous accueille personnellement, dès votre arrivée.',
            hint2: 'Pas d’attente, pas de doute : votre chauffeur est là pour vous.',
            driver: 'Retrouvez facilement votre chauffeur',
        },
        pancarte: 'Accueil personnalisé',
        pancartePlane:
            "Voulez-vous profiter de l'accueil personnalisé ? Votre chauffeur viendra vous chercher avec un pancarte à votre nom.",
        pancarteOn: "Activer l'accueil personnalisé",
        pancarteOff: 'Désactiver',
        pancarteRdv:
            "Votre chauffeur vous attendra à la sortie bagages de votre terminal d'arrivée avec une pancarte à votre nom.",
        rideReason: 'Ajouter le n° de dossier / motif',
        rideReasonTitle: 'N° de dossier / Motif',
        rideReasonDetailsNotMandatory:
            'Vous pouvez ajouter une raison à votre voyage pour chacune de vos réservations :',
        rideReasonDetailsMandatory:
            'Votre entreprise requiert un motif de voyage pour chacune de vos réservations. Veuillez expliquer le motif de cette réservation :',
        driverMessageDesc:
            'Avez-vous des informations supplémentaires à laisser à votre chauffeur concernant votre réservation ?',
        msgToDriver: 'Ajouter un message pour votre chauffeur',
        msgToDriverTitle: 'Message pour votre chauffeur',
        msgToDriverShort: 'Message au chauffeur',
        msgToDriverAuto: 'Toujours définir ce message au chauffeur pour le passager',
        prefilledMessages: {
            gateCode: 'Code du portail',
            wearing: 'Je porte',
            atTheCornerOf: 'Je serais au coin de',
            inFrontOf: 'Je suis en face de',
            doorNumber: 'Numéro de porte',
            nextTo: 'Je suis à côté de',
        },
        recurrence: {
            radio: 'Définir une récurrence pour cette course',
            repeat: 'Répéter le :',
            title: 'Définir une récurrence',
            ride: 'Course récurrente',
            subtitle: 'Jour(s) de la récurrence',
            details:
                'Vos réservations auront lieu tous les Lundi, mardi... Elles seront crées 7 jours avant le début de la prochaine.',
        },
        priceDetail: 'Détails du prix',
        tripDetail: 'Détails du parcours',
        msgHeader: 'Message pour le chauffeur',
        rideNote: 'N° de dossier / Motif',
        addMsg: 'Ajouter ce message au chauffeur',
        whoIsTraveling: 'Qui voyage ?',
        whenAreYouLeaving: 'Programmer ma course',
        chooseFastHour: 'Choisissez dans combien de temps vous souhaitez programmer l’arrivée de votre chauffeur :',
        planTrip: 'Choisissez la date et l’heure de prise en charge par votre chauffeur dans :',
        chooseDateAndHour: 'Choisissez une date et une heure',
        startFrom: 'Départ',
        arriveAt: 'Arrivée',
        estimatedTime: {
            title: 'Choisissez la date et l’heure souhaitée d’arrivée à destination :',
            selectDO: 'Sélectionnez une destination',
            missingPUDO:
                "Vous devez renseigner un point de départ et un point d'arrivé afin que nous puissions estimer votre temps de trajet.",
            duration: 'Temps de trajet estimé pour votre course : <b>{{time}}</b>',
            startDate: 'Heure de départ calculée : <b>{{time}}</b>',
            hint: 'Le trafic réel peut avoir une incidence sur votre heure de dépose. Pour éviter tout risque, merci de prévoir une marge.',
            error: "Afin d'arriver à cette heure vous auriez du déjà partir. Veuillez ajuster votre heure d'arrivée souhaitée.",
        },
        status: {
            not_available: 'Indisponible',
            no_update: "Il n'est pas possible de mettre à jour cette course",
            service_closed: 'Service fermé',
            no_driver_available: 'Aucun chauffeur disponible',
            too_far_away: "Vous êtes trop loin d'un chauffeur disponible",
            region_not_served: "Votre région n'est pas gérée par notre service",
            rider_restricted: "Vous n'avez pas les droits nécessaires pour réserver cette course",
            insufficient_delay: 'Réservable uniquement {{X}} h à l’avance',
            no_pricing_for_area: 'Ce service n’est pas disponible dans votre zone',
            prebook_not_allowed: 'La réservation à l’avance n’est pas disponible',
            asap_not_allowed: 'La prise en charge immédiate n’est pas disponible',
            no_pricing: 'Pas de tarifs disponibles',
            all_driver_busy: 'Désolé, tous nos chauffeurs sont occupés, nous vous invitons à renouveler votre demande.',
            duplicate_ride: 'Vous avez déjà une réservation identique pour ce trajet.',
        },
        dispatchGroup: {
            sncfpap: 'Fiable et abordable',
            normal: 'La rapidité et le confort premium',
            exec: 'Nos meilleurs chauffeurs et véhicules haut de gamme',
            van: 'Le confort pour 6 personnes',
            access: 'Dispose d’une rampe, pour les personnes à mobilité réduite',
        },
        driver: {
            name: 'Votre chauffeur est',
            pu: 'Aller à votre point de rencontre',
        },
        green: {
            title: 'Félicitations',
            details: 'Vous avez choisi un véhicule à faible émission de CO2.',
        },
        toast: {
            created: 'Votre course a été créée avec succès.',
            createdRecurrence: 'Votre récurrence a été créée avec succès.',
            updated: 'Votre course a été mise à jour avec succès.',
            canceledRecurrence: 'Votre récurrence a bien été annulée.',
            cancelError: "Votre course n'a pas pu être annulée. Veuillez réessayer.",
            cancelRecurrentError: "Votre récurrence n'a pas pu être annulée. Veuillez réessayer.",
        },
        nextStepBooking: 'Poursuivre',
        confirmBooking: 'Confirmer ma course',
        confirmedBooking: 'Confirmation de votre course',
        confirmedReservation: 'Confirmation de votre réservation',
        confirmedRecurrence: 'Confirmation de votre récurrence',
        consultAndFollowBooking: 'Consulter et suivre votre course',
        consultBooking: 'Consulter votre course',
        consultRecurrence: 'Consulter votre récurrence',
        bookReturnTrip: 'Réserver le trajet retour',
        addToCalendar: 'Ajouter à mon calendrier',
        newBooking: 'Nouvelle réservation',
        yourTrip: 'Votre trajet',
        creationDate: 'Date de création',
        driverArrival: 'Arrivée du chauffeur',
        bookNewRide: 'Réserver à nouveau',
        shareRide: 'Partager ma course',
        quoteExpired: 'Le tarif de votre course a expiré. Veuillez réessayer.',
        similarRideFound: 'Une course similaire a été trouvée. Voulez-vous continuer malgré tout ?',
    },
    bookingSoon: {
        title: 'Suivez l’état de vos courses en temps réel !',
        bookingNotStarted: 'Course non commencée',
        trip: 'Votre course',
        status: {
            reserved: 'Course réservée',
            processing: 'Attribution d’un chauffeur en cours',
            processingSub: 'Merci de patienter quelques instants',
            noDriver: 'Course annulée. Nos chauffeurs sont tous occupés. Veuillez réitérer votre demande',
            fakeIncoming: 'Un chauffeur se trouve à ',
            incoming: 'Le chauffeur est en approche',
            incomingEta: 'Le chauffeur arrive dans ',
            incomingSub: 'Préparez-vous à son arrivée',
            driverArrived: 'Le chauffeur est arrivé',
            driverArrivedTime: "Le chauffeur est arrivé. Il attendra jusqu'à ",
            driverArrivedSub: 'Il vous attend au point de rendez-vous',
            inProgress: 'Course en cours',
            inProgressEta: 'Course en cours',
            inProgressSub: 'Arrivée prévue à ',
            inProgressFallback: 'Profitez du voyage',
            canceled: 'Course annulée',
            canceledNoCharge: 'Courses annulées sans frais',
            finished: 'Course terminée',
        },
        driverBusy:
            'Nos chauffeurs sont très occupés. Nous nous efforçons de vous en trouver dans les plus brefs délais.',
        orderNew:
            "Vous pouvez commander une autre course et suivre l'état de celle-ci dans le suivi de course à droite de votre écran.",
        orderNewLink: 'Commandez une deuxième course.',
    },
    header: {
        id: 'ID',
        selfService: 'Devenez Prioritaire',
        selfServiceContinue: 'Finaliser ma souscription',
        makeReservation: 'Réserver',
        profil: 'Profil',
        lecab: company,
        company: 'Compagnie',
        admin: 'Administrateur',
        support: 'Aide',
        bookRide: 'Réserver une course',
    },
    drawerMenu: {
        home: 'Accueil',
        profil: 'Profil',
        reservations: 'Réservations',
        favoritesPlaces: 'Favoris',
        tripHistory: 'Historique',
        billing: 'Facturation',
        family: 'Invités',
        payment: 'Paiement',
        promoCode: 'Code Promo',
        support: 'Aide',
        onlyForPerso: 'Uniquement en ',
    },
    adminMenu: {
        groups: 'Groupes',
        collaborators: 'Collaborateurs',
        billing: 'Facturation',
        params: 'Paramètres',
    },
    profile: {
        profile: 'Profil',
        editProfile: 'Éditer mon profil',
        changePwd: 'Modifier mon mot de passe',
        logout: 'Déconnexion',
        logoutMessage: 'Êtes-vous sûr de vouloir vous déconnecter ?',
        undress: "Arrêter l'impersonation",
        editInfos: 'Modifier mes informations',
        editInfosShort: 'Informations',
        editPassword: 'Modifier mon mot de passe',
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        emailPro: 'Email-Pro',
        company: 'Compagnie',
        confirmButton: 'Confirmer',
        cancelButton: 'Annuler',
        password: 'Mot de passe',
        scheduleCourse: 'Programmer',
        scheduleArrival: "Programmer l'arrivée pour",
        scheduleRecurrence: 'Programmer la récurrence',
        newPassword: 'Nouveau mot de passe',
        confirmPassword: 'Confirmer votre mot de passe',
        bookingsInfos: 'Informations courses',
        pickupDefault: 'Prise en charge par défaut',
        dropOffDefault: 'Point de dépose par défaut',
        setPickupAddress: 'Ajouter un point de prise en charge',
        setDropOffAddress: 'Ajouter un point de dépose',
        costCenter: 'Centre de coût',
        costCenterNone: 'Pas de centre de coût',
        costCenterSelect: 'Choisissez un centre de coût',
        costCenterMandatory:
            'Votre entreprise requiert un Centre de Coût pour chacune de vos réservations. Veuillez sélectionner un Centre de Coût.',
        vehicleTypeDefault: 'Véhicule par défaut',
        business: 'Business',
        language: 'Langues',
        languageLabel: 'Langue',
        languageDescription: "Sélectionnez votre langue d'affichage et de communication.",
        dealsTitle: 'Bons plans LeCab',
        dealsDescription: 'Recevoir des offres et informations personnalisées sur mes trajets en LeCab.',
        validatePhone: `Finalisez l'activation de votre compte ${company} en validant votre numéro de téléphone.`,
        validateEmail: `Finalisez l'activation de votre compte ${company}  en validant votre adresse email.`,
        validateEmailAndPhone: `Finalisez l'activation de votre compte ${company}  en validant votre adresse email et votre numéro de téléphone`,
        ctaValidatePhone: 'Envoyer un SMS de validation',
        ctaValidateEmail: "Envoyer un email d'activation",
        validatePhoneTitle: 'Valider votre numéro de téléphone',
        validatePhoneDesc:
            'Valider votre téléphone pour pouvoir contacter votre chauffeur et recevoir les SMS de suivi de course',
        receiveCode: 'Recevoir mon code',
        receiveCodeAlt: 'Recevoir votre code',
        passCode: 'Passez cette fois',
        errorOnPhone: "Impossible d'envoyer un code de vérification. Merci de vérifier votre numéro.",
        errorOnPasswordLost: 'Impossible de modifier votre mot de passe pour le moment. Veuillez réessayer plus tard.',
        errorOnRequestingCode: "Impossible d'envoyer un code pour le moment. Veuillez réessayer plus tard.",
        errorOnSendingCode:
            'Impossible d’effectuer la validation. Merci de vérifier votre code ou de réessayer plus tard.',
        enterCode: 'Saisissez le code à 4 chiffres reçu au {{phone}}',
        code: 'Code',
        sendCodeAgain: 'Renvoyer le code',
        validationSuccess: 'Votre numéro a bien été validé',
        checkMailbox: 'Vérifiez votre boîte mail',
        checkMailboxDescFirstPart:
            "Pour réinitialiser votre mot de passe, veuillez cliquer sur le lien que nous venons de vous envoyer à l'adresse : ",
        checkMailboxDescSecondPart: 'Si vous ne l’avez pas reçu, ',
        checkMailBoxCTA: "renvoyer l'email",
        successResendEmail: "Un nouvel email vient d'être envoyé.",
        editPhone: 'Modifier mon numéro de téléphone',
        editPhoneShort: 'Numéro de téléphone',
        addPhone: 'Ajouter un numéro de téléphone',
        addPhoneDesc: 'Complétez votre profil avec un numéro de téléphone',
        phoneNumber: 'Numéro de téléphone',
        sentCode: 'Code envoyé',
        datas: 'Données et caches',
        resetCache: 'Supprimer les adresses et passagers récents',
        resetCacheDeleted: 'Adresses et passagers récents supprimés',
        privacy: 'Confidentialité',
        legalInfos: 'Informations légales',
        rgpd: 'Gestion des cookies et autres traceurs',
        deleteAccount: 'Supprimer mon compte',
        deleteAccountMessage: 'Êtes-vous sûr de vouloir supprimer votre compte LeCab ?',
        deleteAccountSuccessMessage:
            'Votre compte LeCab a été supprimé avec succès. Il sera désactivé dans un délai de deux jours ouvrés par nos équipes.',
        legale: {
            cgv: 'Conditions Générales de Vente',
            mentions: 'Mentions légales',
            confidential: 'Politiques de condidentialités',
            exportRGPD: 'Exporter mes données',
            exportRGPDDescription: 'Veuillez entrer votre mot de passe, afin de confirmer votre identité.',
            exportAsked: 'Votre demande a bien été prise en compte.',
            exportAskedDate: `Demande effectuée le {{date}}.`,
            exportAskedDescription: 'Vous recevrez vos données par email dans les prochains jours.',
        },
    },
    language: {
        fr: 'Français',
        en: 'Anglais',
    },
    appearance: {
        light: 'Mode clair',
        dark: 'Mode sombre',
    },
    roles: {
        title: 'Rôles',
        principal: 'Administrateur',
        rider: 'Passager',
        booker: 'Réservataire',
    },
    userTypes: {
        coworker: 'Collègue',
        guest: 'Invité',
        invite: 'Invitation en cours',
    },
    reservation: {
        reservations: 'Réservations',
        reservation: 'Réservation',
        filters: 'Filtres',
        number: 'Numéro de réservation',
        booking: 'Course n° ',
        booked: 'Réservé par ',
        passenger: 'Passager',
        bookReturnRide: 'Réserver le trajet de retour',
        messageToDriver: 'Message au chauffeur',
        addToCalendar: 'Ajouter au calendrier',
        editReservation: 'Modifier la réservation (trajet, date et gamme)',
        sosReservation: 'Signaler un problème de sécurité urgent',
        cancelReservation: 'Annuler ma réservation',
        pauseRecurrent: 'Mettre la récurrence en pause',
        unPauseRecurrent: 'Réactiver',
        cancelPauseRecurrent: 'Annuler la mise en pause',
        cancelRecurrent: 'Annuler la récurrence',
        cancelRecurrentConfirm: 'Êtes-vous sûr de vouloir annuler la récurrence ?',
        noReservationsYet: "Vous n'avez aucune course prochainement prévue.",
        noReservationsNow: "Vous n'avez aucune course en cours.",
        planNewTrip: 'Programmez une course',
        noReservationsDescription: "Réservez votre premier trajet aujourd'hui !",
    },
    recurrence: {
        reservation: {
            paused: 'Votre récurrence est en pause jusqu’au ',
            willPause: 'Votre récurrence sera en pause du ',
        },
        pause: 'Mettre en pause',
        paused: 'En pause',
        title: 'Combien de temps souhaitez vous mettre en pause votre récurrence ?',
        hint: 'Si une ou plusieurs courses étaient déjà prévues pour la semaine en cours, vous devrez les annuler dans vos réservations à venir.',
        creation: "Chaque nouvelle réservation sera créée une semaine à l'avance.",
    },
    sos: {
        title: 'Signaler un problème de sécurité',
        action: 'Être rappelé(e)',
        actionUrgence: 'Contacter le 112',
        descriptionLong:
            'Si vous vous trouvez actuellement dans une <b>situation dangereuse, urgente et grave</b>, cliquez sur le bouton ci-dessous.<br><br>Nos équipes sont <b>préparées</b> et vous <b>rappellerons immédiatement</b> afin de comprendre la situation et trouver une solution sans risque.',
        description:
            'Chez LeCab, votre sécurité est notre priorité absolue. Si vous vous trouvez actuellement dans une situation inconfortable ou si vous ressentez le moindre danger pendant votre trajet, nous sommes là pour vous apporter notre assistance.',
        description2:
            "En cliquant sur le bouton ci-dessous, nos équipes seront immédiatement informées de votre besoin d'assistance. Lors du rappel, nous vous poserons des questions afin de mieux comprendre la situation et de prendre les mesures nécessaires pour garantir votre sécurité.",
        sent: 'Demande envoyé',
        info: "Suite à votre demande, nos équipes ont été alertées et vous rappelleront dans les prochains instants. Afin de prendre les mesures nécessaires pour garantir votre sécurité, veuillez répondre aux questions de nos équipes en utilisant 'Oui' ou 'Non'.",
        enabled: {
            title: 'Prise de contact en cours',
            description: 'Vous allez recevoir un appel dans quelques secondes.',
            cancel: 'Annuler ma demande',
        },
    },
    policies: {
        costCenter: {
            header: 'Centres de coût',
            headerDescription: 'Pas de centre de coût',
            headerDescriptionActive: '{{number}} centre(s) de coût',
            subtitle: 'Organisez et catégorisez vos factures.',
            any: 'Aucun centre de coût',
            limit: 'Avec des centres de coûts',
            title: "Ajoutez des centres de coût et définissez leurs conditions d'utilisation.",
            defaultValue: 'Définir un centre de coût par défaut',
            defaultNo: 'Pas de centre de cout par défaut -  À définir à chaque course',
            defaultAll: 'Définir un centre de coût par défaut pour tous les utilisateurs du groupe',
            defaultPerUser: 'Définir un centre de coût par défaut par utilisateur',
            defaultPerUserHint:
                'Vous pourrez définir un centre de coût par utilisateur dans la liste des collaborateurs du groupe.',
            required: 'Rendre le centre de coût obligatoire à la réservation',
            actions: {
                add: 'Ajouter un centre de coût',
                import: 'Importer des centres',
                export: 'Exporter les centres',
                default: 'Par défaut',
            },
            modal: {
                add: 'Ajouter un centre de coût',
                edit: 'Modifier le centre de coût',
                form: {
                    name: 'Nom',
                    description: 'Description',
                    duplicateName: 'Ce nom est déjà utilisé par un autre centre de coût.',
                },
            },
        },
        places: {
            header: 'Paramètres géographiques',
            headerDescription: 'Aucun paramètre appliqué',
            headerDescriptionActive: '{{number}} paramètre(s) actif(s)',
            subtitle: 'Facilitez et / ou limitez les réservations de vos collaborateurs.',
            title: 'Sélectionnez les paramètres à appliquer à vos collaborateurs',
            description: 'Vous pouvez choisir plusieurs possibilités.',
            radiusDesc: "Définissez le rayon de la zone d'autorisation",
            areaName: 'Nom de la zone',
            options: {
                defaultAddresses: 'Adresses par défaut',
                defaultPerGroup: 'Pour tous les utilisateurs du groupe',
                defaultPickup: 'Un point de départ par défaut',
                defaultPickupCTA: 'Définir un point de départ par défaut',
                defaultPickupPerUser: 'Définir un point de départ par défaut par utilisateur',
                defaultPickupPerUserDesc:
                    'Vous pourrez définir un point de départ par utilisateur dans la gestion des collaborateurs associé au groupe.',
                defaultPickupDescModal:
                    'Définissez un point de départ par défaut pour chacune des réservations des collaborateurs de ce groupe.',
                defaultDropoff: "Un point d'arrivée par défaut",
                defaultDropOffCTA: "Définir un point d'arrivée par défaut",
                defaultDropOffPerUser: "Définir un point d'arrivée par défaut par utilisateur",
                defaultDropOffPerUserDesc:
                    "Vous pourrez définir un point d'arrivée par utilisateur dans la gestion des collaborateurs associé au groupe.",
                defaultDropOffDescModal:
                    "Définissez un point d'arrivée par défaut pour chacune des réservations des collaborateurs de ce groupe.",
                favorites: 'Définir des adresses favorites',
                favorite: 'Définir une adresse favorite',
                setAsWorkAddress: 'Définir comme adresse de travail du groupe',
                setAsWorkAddressDesc:
                    'Elle apparaîtra comme « Travail » dans l’application des collaborateurs du groupe.',
                workAddressTaken:
                    'Une adresse de travail est déjà définie pour ce groupe : elle sera remplacée par celle-ci.',
                replaceWorkAddress: "Remplacer l'adresse de travail",
                replaceWorkAddressConfirm:
                    '« {{name}} » est actuellement l’adresse de travail du groupe. Elle sera conservée comme simple adresse favorite. Confirmer le remplacement ?',
                favoritesSub: 'Les utilisateurs du groupe pourront facilement les retrouver sur leur application.',
                noFavorite: "Vous n'avez aucune adresse favorite",
                addFavorites: 'Ajouter des adresses',
                addAreas: 'Ajouter des zones',
                areasCount: 'Vous avez {{X}} zone(s) définie(s)',
                noAreas: "Vous n'avez aucune zone d'autorisation définie",
                favoritesCount: 'Vous avez {{X}} adresse(s) favorite(s)',
                areasSetUp: 'Paramétrer une zone d’autorisation de courses',
                areasSetUpSub:
                    'Les utilisateurs du groupe ne pourront réserver leur lieu de prise en charge et leur destination que dans ces zones géographiques.',
                areas: 'Paramétrer une zone d’autorisation',
                areaRadius: 'Rayon en KM',
                addressAuthorization: 'Définissez quel(s) point(s) doit(vent) se trouver dans la zone',
                pickupRadius: 'Un point de départ',
                dropoffRadius: "Un point d'arrivée",
            },
        },
        day: {
            header: 'Restrictions horaires',
            headerDescription: 'Aucune politique appliquée',
            headerDescriptionActive: '{{number}} politique(s) appliquée(s)',
            subtitle: 'Définissez quand vos collaborateurs pourront réserver leurs courses.',
            any: 'Aucun',
            limit: 'Jours et heures personnalisées',
            title: 'Définissez les jours et plages horaires autorisés',
            description:
                'Restreindre les collaborateurs de ce groupe à se déplacer certains jours spécifiques de la semaine et/ou à des heures de la journée.',
            startHour: 'Heure de début',
            to: 'à',
            endHour: 'Heure de fin',
            addHours: 'Ajouter des heures',
        },
        limit: {
            header: 'Limites & paramètres de réservations',
            headerDescription: 'Aucune limite',
            headerDescriptionActive: '{{number}} paramètre(s) actif(s)',
            subtitle: 'Définissez précisément les possibilités de réservation de vos collaborateurs.',
            title: 'Définissez les limites et les paramètres de réservations de vos courses.',
            description: 'Vous pouvez choisir plusieurs possibilités.',
            options: {
                bookForColleague: 'Réserver pour un collègue',
                bookForColleagueSub: 'Une personne du même groupe.',
                bookForGuest: 'Faire voyager un invité',
                bookForGuestSub: 'Une personne hors de votre organisation.',
                reservationLimit: 'Limite de réservations',
                reservationLimitHint:
                    'Définissez le nombre de courses maximum qu’un collaborateur peut effectuer dans une période donnée.',
                reservationLimitRideNumber: 'Nombre de courses',
                spendingLimit: 'Plafond de dépense',
                spendingLimitHint:
                    'Définissez le montant maximum qu’un collaborateur peut utiliser dans un temps imparti.',
                noTip: 'Interdire les pourboires',
                rideReasonMandatory: 'N°de dossier / Motif obligatoire pour réserver',
            },
        },
        service: {
            header: 'Gammes autorisées',
            headerDescription: 'Toutes les gammes autorisées',
            headerDescriptionActive: '{{number}} gamme(s) autorisée(s)',
            subtitle: 'Contrôlez vos dépenses en n’autorisant que certaines gammes de véhicules.',
            service: {
                title: 'Quels sont les services autorisés pour vos collaborateurs ?',
                description: 'Vous pouvez choisir plusieurs services.',
                options: {
                    asap: 'Course immédiate',
                    prebook: 'Programmation',
                    mad: 'Mise à disposition',
                    free: 'Course libre',
                },
            },
            gamme: {
                title: 'Définissez les gammes autorisées sur ce groupe',
                description: 'Vous pouvez choisir plusieurs gammes.',
                default: 'Définissez une gamme par défaut :',
                defaultPlaceholder: 'Gamme par défaut',
            },
        },
    },
    errors: {
        cbRefuse:
            "L'ajout de votre carte a été refusé. Veuillez réessayer plus tard ou utiliser un autre moyen de paiement.",
        canNotBeEmpty: 'Le champ ne peut être vide',
        invalidFormat: 'Format non valide',
        paramsIncorrect: 'Paramètres incorrects, veuillez réessayer.',
        defaultError: 'Une erreur inconnue est survenue',
        clientError:
            'Une erreur est survenue ! Veuillez nous excuser pour la gêne occasionnée.<br/>Nous travaillons à sa résolution au plus vite. Merci de votre patience.',
        error: "Quelque chose s'est mal passé",
        video: 'Votre navigateur ne supporte pas la balise vidéo.',
        offline: 'Veuillez vérifier votre connexion Internet.',
        phoneHomeError:
            'Vous devez renseigner un numéro de téléphone portable afin de pouvoir recevoir les SMS de suivi de votre course ainsi que joindre votre chauffeur.',
        phoneInvalidError: 'Numéro invalide, veuillez corriger votre numéro.',
    },
    download: {
        ios: 'LeCab pour IOS',
        android: 'LeCab pour Android',
    },
    common: {
        in: 'Dans',
        or: 'Ou',
        yes: 'Oui',
        no: 'Non',
        free: 'Offert',
        per: 'Par',
        euro: 'Euros',
        continue: 'Continuer',
        loading: 'Chargement',
        none: 'Aucun',
        plan: 'Planifier',
        optional: '(optionnel)',
        retry: 'Réessayer',
        infoRecall: 'Ces informations vous seront rappelées durant votre course.',
        from: 'De',
        to: 'Vers',
        at: 'à',
        incoming: 'À venir',
        inProgress: 'En cours',
        recurrence: 'Récurrence',
        gotIt: "J'ai compris !",
        confirm: 'Confirmer',
        validate: 'Valider',
        add: 'Ajouter',
        added: 'Ajouté',
        back: 'Retour',
        backToList: 'Revenir à la liste',
        prev: 'Précédent',
        next: 'Suivant',
        edit: 'Modifier',
        edited: 'Modifié',
        warning: 'Attention',
        delete: 'Supprimer',
        deleted: 'Supprimé',
        schedule: 'Programmer',
        deleteHint: 'Êtes-vous sûr de vouloir supprimer : {{details}} ?',
        reset: 'Réinitialiser',
        search: 'Recherche',
        searchVerb: 'Rechercher',
        noResult: 'Aucun résultat',
        perso: 'Perso',
        pro: 'Pro',
        dot: '•',
        rideBetween: 'Courses entre',
        displayRidesBetween: 'Afficher les courses entre ces dates',
        date: 'Date',
        startDateLabel: 'Date de début',
        endDateLabel: 'Date de fin',
        startLabel: 'Début de course',
        endLabel: 'Fin de course',
        number: 'Numéro',
        group: 'Groupe',
        ttc: 'TTC',
        totalHT: 'Total HT',
        tva: 'TVA',
        resetFilter: 'Réinitialiser les filtres',
        clear: 'Effacer',
        cancel: 'Annuler',
        cancelRide: 'Annuler la course',
        cancelled: 'Annulée',
        save: 'Sauvegarder',
        saved: 'Sauvegardé',
        skip: 'Passer',
        knowMore: 'En savoir plus',
        more: 'Voir plus',
        see: 'Voir',
        reduce: 'Réduire',
        all: 'Tous',
        export: 'Exporter',
        maintenance: 'Maintenance en cours',
        resendEmail: 'Renvoyer par e-mail',
        downloadPdf: 'Télécharger le PDF',
        download: 'Télécharger',
        retryLater: 'Une erreur est survenue, veuillez réessayer plus tard.',
        numberOnly: '(chiffres uniquement)',
        min: 'minimum',
        max: 'maximum',
        char: 'caractère',
        chars: 'caractères',
        details: 'Détails',
        driver: 'Chauffeur',
        later: 'Plus tard',
        thanks: 'Merci',
        yourDriver: 'votre chauffeur',
        copy: 'Copier dans le presse-papier',
        copied: 'Copié dans le presse-papier',
        copyFailed: 'Copie échouée',
        editNotSaved: "Attention, vous n'avez pas sauvegardé vos changements. Voulez-vous quand même quitter ?",
        france: 'France',
    },
    filter: {
        action: 'Appliquer',
        filters: 'Filtres',
        description: "Ajouter des filtres afin d'affiner la liste des réservations affichées.",
        infoSection: 'Filtrer par informations de réservation :',
        periodSection: 'Filtrer par période :',
        groupSection: 'Filtrer par groupe :',
        showCanceledNoCharge: 'Afficher les courses annulées sans frais',
        exportSelection: 'Exporter la sélection',
        exportRealSelection: 'Exporter la sélection réelle',
        errors: {
            noInterval: 'Sélectionner un intervalle de date à exporter',
            before2022: 'Vous ne pouvez exporter que les courses à partir de Janvier 2022',
        },
    },
    time: {
        placeholder: 'jj/mm/aaaa',
        timePlaceholder: 'hh:mm',
        hourFormat: 'HH[h]mm',
        recurrenceFormat: 'DD MMMM yyyy',
        baseFormat: 'ddd DD MMMM',
        completeFormat: 'ddd DD MMM [à] HH:mm[.]',
        lettreFormat: 'ddd DD MMMM [à] HH:mm',
        lettreFormatBold: 'ddd DD MMMM [à] [<b>]HH:mm[</b>]',
        lettreFormatBoldShort: 'ddd DD MMM [à] [<b>]HH:mm[</b>]',
        isoFormat: 'yyyy-MM-DD[T]HH:mm',
        slashFormat: 'DD/MM/yyyy',
        shortFormat: 'DD/MM HH:mm',
        dayFormat: 'dddd',
        h: 'h',
        m: 'm',
        s: 's',
        hour: 'heure',
        hours: 'heures',
        minute: 'minute',
        minutes: 'minutes',
        min: 'min',
        mins: 'mins',
        seconds: 'secondes',
        day: 'Jour',
        week: 'Semaine',
        weekend: 'Fin de semaine',
        allDays: 'Tous les jours',
        prefixRecurrence: 'Tous les',
        month: 'Mois',
        year: 'Année',
        mon: 'Lundi',
        tue: 'Mardi',
        wed: 'Mercredi',
        thu: 'Jeudi',
        fri: 'Vendredi',
        sat: 'Samedi',
        sun: 'Dimanche',
        now: 'Maintenant',
        to: 'au',
    },
    tripHistory: {
        history: 'Historique',
        needSomeHelp: 'Obtenir de l’aide pour cette course',
        reportIncident: 'Signaler un incident',
        bookingTheSame: 'Réserver à nouveau',
        noHistory: 'Vous n’avez passé encore aucune course. C’est le moment,',
        noHistoryLink: 'programmez une course !',
        receipt: 'Facture',
        receiptInProgress: 'Facture en cours de génération',
        recapInProgress: 'Récapitulatif cours de génération',
        downloadRecap: 'Télécharger le récapitulatif',
        downloadReceipt: 'Télécharger la facture',
        canceledWithCharge:
            "Cette course vous a été facturée {{price}} car l'annulation a été faite après le temps limite.",
        tipsAndRating: {
            how: 'Comment s’est passé votre course ?',
            add: 'Ajouter une note et un pourboire',
            title: 'Notez votre course',
            booking: `Course du {{date}} vers {{destination}}`,
            thanks: `Merci d'avoir choisi ${company} ! Nous sommes ravis de vous avoir transporté(e) à votre destination.`,
            rating: 'Comment évalueriez-vous votre course ?',
            ratingThanks: {
                title: 'Merci pour votre note !',
                description: 'Votre avis sera pris en compte.',
            },
            yourRating: 'Votre note',
            yourFeedback: 'Vos retours',
            yourComment: 'Votre commentaire',
            comment: 'Puisque la qualité de notre service est essentielle, votre avis nous est précieux !',
            commentPlaceholder: 'Ajouter un commentaire',
            tip: 'Pourboire',
            tipAdd: 'Donner un pourboire',
            tipQuestion: 'Souhaitez vous laisser un pourboire à {{driver}} ? (facultatif)',
            tipCustom: 'Ajouter un montant personnalisé',
            tipCustomShort: 'Montant personnalisé',
            tipCustomPlaceholder: 'Pourboire personnalisé',
            tipTitle: 'Laissez un pourboire à {{driver}} (Facultatif)',
            tipMax: 'Pourboire maximum : {{amount}}€',
            tipNo: 'Ne pas donner',
            tipThanks: {
                title: 'Merci pour votre pourboire de {{amount}}',
                description: '{{name}} sera ravi(e)',
                toDriver: 'La totalité de cette somme revient à votre chauffeur.',
            },
            soon: 'Vous pouvez désormais noter la course et donner un pourboire à votre chauffeur.',
        },
    },
    empty: {
        search: 'Aucun élément ne correspond à votre recherche. Veuillez modifier les termes de votre recherche.',
        tripHistory: 'Vous n’avez encore réalisé aucune course.',
        inProgress: 'Vous n’avez aucune course en cours.',
        scheduled: 'Vous n’avez aucune course à venir.',
        recurrence: 'Vous n’avez aucune course récurrente.',
        recurrenceInfo:
            'Une course récurrente est une course qui se répète automatiquement, pour un jour et une heure indiqués.',
        filter: 'Aucune course ne correspond aux filtres. Veuillez modifier les filtres sélectionnés.',
    },
    favorites: {
        favoritesAlternative: 'Adresses favorites',
        favorites: 'Vos lieux préférés',
        addFavorite: 'Ajouter un favori',
        addFavoriteAlternative: 'Ajouter une adresse',
        addFavoriteAlternativeShort: 'Adresse',
        addNewName: "Nom de l'adresse",
        addNewAddress: 'Adresse',
        work: 'Travail',
        home: 'Maison',
        favorite: 'Favori',
        defineWorkAddress: "Définir l'adresse de travail",
        defineWorkAddressShort: 'Adresse de travail',
        defineHomeAddress: "Définir l'adresse de domicile",
        defineHomeAddressShort: 'Adresse de domicile',
        defineFavAddress: 'Définir un favori',
        defineFavAddressShort: 'Favori',
        addSuccess: '{{name}} ajouté(e) avec succès',
        editError: 'Désolé, nous n’avons pas réussi à modifier cette adresse. Veuillez réessayer ultérieurement',
        addError: 'Désolé, nous n’avons pas réussi à ajouter cette adresse. Veuillez réessayer ultérieurement',
        deleteError: 'Désolé, nous n’avons pas réussi à supprimer cette adresse. Veuillez réessayer ultérieurement',
        deleteFavoriteConfirm: 'Êtes-vous sûr de vouloir supprimer l’adresse favorite {{name}} ?',
        cantLocate: 'Adresse introuvable ?',
        locateOnMap: 'Pointez-la sur la carte',
        selectOnMap: "Vous pouvez définir l'adresse en déplaçant le point sur la carte",
    },
    family: {
        familyMembers: 'Invités',
        familyHint:
            'Créez des passagers invités afin de les faire voyager avec LeCab, sans besoin de télécharger l’application.',
        firstname: 'Prénom',
        lastname: 'Nom',
        nickname: 'Surnom (optionnel)',
        phoneNumber: 'Téléphone',
        addMember: 'Ajouter un invité',
        editMember: 'Modifier un invité',
        noMember: 'Vous n’avez encore aucun invité.',
        maxNumberReached: 'Vous êtes limités à 4 membres de la famille',
        confirmDelete: "Êtes-vous sûr de vouloir supprimer l'invité : {{firstname}} {{lastname}} ?",
    },
    promo: {
        usePromoCode: 'Utiliser un code promo',
        usePromoCodeDescription: "Ajoutez un code promo afin d'en profiter sur vos prochaines courses !",
        promoCode: 'Code promo',
        listingTitle: 'Vos codes promos',
        listingDescription: 'Nous appliquons pour vous le meilleur code promo pour vos courses.',
        getFreeRide: 'Avoir une course gratuite',
        promoAdded: 'Code promo ajouté',
        noPromo: 'Vous n’avez pas de code promo actif.',
        expired: 'Expiré',
        consumed: 'Déjà utilisé',
        noLimit: 'Utilisation illimitée',
        useLeft: 'utilisation(s) restante(s)',
        applied: 'Code promo appliqué {{code}}',
        codeApplied: 'Code appliqué',
    },
    payment: {
        paymentAdd: 'Ajouter un moyen de paiement',
        editCardName: 'Modifier le nom de la carte',
        cardName: 'Nom sur la carte',
        brand: 'Type',
        num: 'Num',
        status: 'Statut',
        expire: 'Expire',
        expired: 'Carte expirée',
        saving: "Finalisation de l'enregistrement",
        redirectDoneTitle: 'Traitement terminé',
        redirectDoneHint: 'Vous pouvez revenir à vos moyens de paiement en utilisant la flèche en haut à gauche.',
        paymentDefault: 'Moyen de paiement par défaut',
        paymentDefaultHint: 'Configurez vos moyens de paiement par défaut pour chacun de vos groupes.',
        default: 'Carte par défaut',
        noSetting: 'Configuration de ce groupe introuvable',
        onboard: 'Paiement à bord, vous devrez régler à bord à la fin de votre course directement à votre chauffeur',
        centralized: 'Paiement centralisé, les coûts sont gérés par votre entreprise',
        noCard: 'Veuillez ajouter un moyen de paiement pour pouvoir commander un Cab.',
        errors: {
            defaultCardUpdate:
                'Nous n’avons pas réussi à définir votre carte par défaut. Pas de panique, vous pouvez tout de même réserver une course et réessayer ultérieurement.',
            cardDeletion: 'Désolé, nous n’avons pas réussi à supprimer votre carte. Veuillez réessayer ultérieurement',
            cancelled: 'L’opération a été annulée. Veuillez réessayer plus tard.',
            error: 'Une erreur est apparue. Veuillez réessayer plus tard.',
            refused: 'Le paiement a été refusé.',
        },
    },
    paymentType: {
        cash: 'Liquide',
        paypal: 'Paypal',
        creditCard: 'Carte de crédit',
        applePay: 'Apple pay',
        invoice: 'Prépayé',
        onboard: 'Paiement à bord',
        mensual: 'Paiement mensuel',
        individual: 'Paiement individuel',
        centralized: 'Paiement centralisé',
        short: {
            individual: 'Pai. individuel',
            centralized: 'Pai. centralisé',
            onboard: 'À bord',
        },
    },
    onboardPayment: {
        title: 'Paiement à bord',
        trackingDescription: 'Une fois terminée, votre course devra être payée directement auprès de votre chauffeur.',
        description:
            'Payer votre course à votre chauffeur directement via l’une de nos deux options de paiement à bord :',
        contactlessTitle: 'Paiement sans contact',
        contactlessDescription: 'Votre chauffeur n’aura accès à aucune de vos informations de paiement',
        cashTitle: 'Paiement en espèce',
        terminalTitle: 'TPE',
        terminalDescription: 'Certains de nos chauffeurs disposent d’un TPE (Terminal de Paiement Électronique)',
        validate: 'J’ai compris',
    },
    paymentClearance: {
        alertTitleOne: 'Une course attend une régularisation',
        alertTitleMany: 'Plusieurs courses attendent une régularisation',
        alertDescriptionOne:
            'Le moyen de paiement d’une de vos courses n’a pas pu être validé. Sans régularisation, elle sera annulée avant son départ.',
        alertDescriptionMany:
            'Le moyen de paiement de {{count}} de vos courses n’a pas pu être validé. Sans régularisation, elles seront annulées avant leur départ.',
        badge: 'Paiement à régulariser',
        blockedTitle: 'Paiement refusé',
        blockedDescription:
            'Votre moyen de paiement n’a pas pu être validé pour cette course. Changez-en dès maintenant : la validation repart toute seule, sans autre action de votre part.',
        blockedCta: 'Changer de moyen de paiement',
        cancelledTitle: 'Course annulée — paiement non validé',
        cancelledDescription: 'Cette course a été annulée car son moyen de paiement n’a pas pu être validé à temps.',
        cancelledCta: 'Réserver à nouveau',
        close: 'Fermer',
        // Encart affiché dans le détail d’une course (LT-1884) — le
        // « commentaire » lisible sans rien ouvrir, une fois la modale fermée.
        detailsBlocked:
            'Paiement refusé. Sans un moyen de paiement valide, cette course sera annulée deux heures avant son départ.',
        detailsBlockedCta: 'Changer de moyen de paiement',
        detailsCancelled: 'Course annulée : son moyen de paiement n’a pas pu être validé à temps.',
    },
    status: {
        created: 'Créé',
        readyToDispatch: 'Prêt à être délivré',
        processing: 'En cours de traitement',
        allocated: 'Alloué',
        received: 'Reçu',
        seen: 'Vu',
        accepted: 'Accepté',
        onWay: 'En chemin',
        atPickup: 'Au point de départ',
        passengerOnBoard: 'Passager sur le bord',
        dropIn5: 'Dépose dans 5 minutes',
        atDropOff: "Au point d'arrivée",
        finished: 'Terminé',
        cancelled: 'Annulé',
        cancellationNoCharge: 'Annulé sans frais',
        cancellationWithCharge: 'Annulé avec frais',
    },
    table: {
        groups: 'Groupes',
        admin: 'Administrateur',
        members: 'Membres',
        actions: 'Actions',
        dateAdded: "Date d'ajout",
    },
    importBulk: {
        uploadStep: {
            title: 'Téléchargement du fichier',
            manifestTitle: '',
            manifestDescription:
                'Ajoutez plusieurs collaborateurs simultanément à ce groupe en important une feuille de calcul. Pour commencer, téléchargez votre fichier contenant les informations présentées ci-dessous. Vous pourrez modifier leur rôle au sein de ce groupe par la suite.',
            manifestDescriptionInvite:
                'Invitez plusieurs collaborateurs simultanément à ce groupe en important une feuille de calcul. Pour commencer, téléchargez votre fichier contenant les informations présentées ci-dessous. Une invitation à rejoindre ce groupe leur sera envoyée par e-mail. Vous pourrez modifier leur rôle au sein de ce groupe par la suite.',
            maxRecordsExceeded: 'Trop de lignes dans le fichier. Maximum {{X}} autorisées',
            dropzone: {
                title: 'Formats acceptés : .xlsx, .xls ou .csv',
                errorToastDescription: 'Téléchargement rejeté',
                activeDropzoneTitle: 'Déposer le fichier en le glissant ici...',
                buttonTitle: 'Sélectionner un fichier',
                loadingTitle: 'Chargement...',
            },
            selectSheet: {
                title: 'Sélectionnez le fichier à importer.',
                nextButtonTitle: 'Suivant',
            },
        },
        selectHeaderStep: {
            title: 'Sélection des titres',
            nextButtonTitle: 'Suivant',
        },
        matchColumnsStep: {
            title: 'Sélection des données',
            nextButtonTitle: 'Suivant',
            userTableTitle: 'Votre fichier',
            templateTitle: 'Sélectionnez les titres des colonnes correspondantes',
            selectPlaceholder: 'Sélectionnez un titre',
            ignoredColumnText: 'Colonne ignorée',
            subSelectPlaceholder: 'Sélectionnez',
            matchDropdownTitle: 'correspond',
            unmatched: 'Désélectionner',
            duplicateColumnWarningTitle: 'Ce nom de colonne a déjà été sélectionné.',
            duplicateColumnWarningDescription: 'Les colonnes doivent être uniques',
        },
        validation: {
            emailInvalid: "Format d'e-mail non valide",
            emailMissing: 'Le champ e-mail est obligatoire',
            firstnameMissing: 'Le champ prénom est obligatoire',
            lastnameMissing: 'Le champ nom est obligatoire',
        },
        validationStep: {
            title: 'Valider le tableau',
            nextButtonTitle: 'Confirmer les informations',
            noRowsMessage: 'Pas de données',
            noRowsMessageWhenFiltered: 'Aucune erreur trouvée',
            discardButtonTitle: 'Supprimer les lignes sélectionnées',
            filterSwitchTitle: 'Afficher uniquement les lignes erronées',
        },
        alerts: {
            confirmClose: {
                headerTitle: "Quitter le parcours d'import",
                bodyText: 'Êtes-vous sûr ? Aucune donnée ne sera sauvegardée',
                cancelButtonTitle: 'Annuler',
                exitButtonTitle: 'Quitter',
            },
            submitIncomplete: {
                headerTitle: 'Erreurs détectées',
                bodyText: 'Il existe toujours des lignes avec des erreurs. Elles seront ignorées.',
                bodyTextSubmitForbidden: 'Une ou plusieurs lignes contiennent des erreurs',
                cancelButtonTitle: 'Annuler',
                finishButtonTitle: 'Confirmer',
            },
            unmatchedRequiredFields: {
                headerTitle: 'Informations manquantes',
                bodyText: 'Certaines colonnes obligatoires ne sont pas attribuées.',
                listTitle: 'Colonne(s) non attribuée(s) :',
                cancelButtonTitle: 'Annuler',
                continueButtonTitle: 'Continuer',
            },
            toast: {
                error: 'Une erreur inconnue est survenue',
            },
        },
    },
    selfService: {
        common: {
            free: 'Gratuit',
            perMonth: 'par mois',
            upTo: "jusqu'à",
            maxUser: 'utilisateur max',
            maxUsers: 'utilisateur(s) max',
            select: "Sélectionner l'offre",
            custom: 'Selon conditions',
            nbUsers: "Nombre d'utilisateurs",
            unlimited: 'ILLIMITÉ',
            benefits: {
                title: 'Les avantages',
                policies: 'Politique voyages intégrée',
                budget: 'Maîtrise budgétaire',
                premium: 'La qualité premium',
                reservation: 'Processus de réservation simplifié',
                vip: 'Statut Client prioritaire',
                infinity: 'Gamme infinite',
                colleagues: 'Réserver pour les collaborateurs',
                guests: 'Réserver pour un invité',
                costCenters: 'Centres de coûts',
                billingCostCenters: 'Facturation par centre de coûts',
                sales: 'Interlocuteur dédié',
                a: 'Réservez vos courses à l’avance',
                b: 'Prix fixes aux aéroports',
                c: 'Facturation au nom de l’entreprise',
                cbis: 'Facturation centralisée au nom de l’entreprise',
                d: 'Statut prioritaire',
                e: 'Limité à 1 utilisateurs',
                ebis: 'Limité à 5 utilisateurs',
                eter: 'Réservez pour 20 invités gratuitement (*)',
                equa: 'Utilisateurs et invités illimités',
                f: 'Restrictions géographiques et horaires',
                g: 'Interlocuteur dédié',
            },
            hints: {
                policies1: "Workflow d'approbation optimisé",
                policies2: 'Soutien de vos démarches RSE ',
                policies3: 'Sécurité et confidentialité assurées',
                budget1: 'Facturation instantanée',
                budget2: 'Tarif fixe dès la réservation',
                vip1: 'Réservation en mode prioritaire',
                vip2: 'Les meilleurs chauffeurs',
                colleagues: 'Passez les réservations des collègues de votre groupe',
                guests: 'Créez des réservations pour vos invités (jusqu’à 20 par mois*)',
                guestsPricing:
                    '*Les utilisateurs supplémentaires seront facturés--€/utilisateurs et les invités à --€/invités',
                costCenters: 'Associez des centre de coûts à vos réservations',
                billingCostCenters: 'Limitez les déplacement à des zones géographique ou des plages horaires',
            },
        },
        formula: {
            title: 'Nos formules',
            description: "Choisissez l'offre correspondant à vos besoins en mobilité",
            additional:
                '*Les utilisateurs supplémentaires seront facturés {{userPrice}}€/utilisateurs et les invités à {{guestPrice}}€/invités',
            modify: 'Changer de formule',
            modifyDesc:
                'Attention ! Certains avantages de la formule choisie peuvent ne plus être disponibles dans votre nouveau choix.',
        },
        policies: {
            title: 'Politiques de voyage',
            description:
                "Choisissez des politiques de voyage à appliquer à votre premier groupe pour personnaliser l'expérience de réservation et de voyage de vos collaborateurs.",
        },
        payment: {
            title: 'Ajoutez votre moyen de paiement',
            descFirstPart:
                'Il sera utilisé pour le paiement de vos courses et votre abonnement en fonction de la formule choisie.',
            descSecondPart:
                'Pour vérifier vos informations, une demande d’autorisation de prélèvement temporaire est effectuée. Elle est immédiatement annulée et son montant ne vous est pas facturé.',
        },
        settings: {
            title: 'Paramétrer votre paiement',
            description:
                'Définissez la politique de paiement de votre entreprise. Vous pourrez la modifier ultérieurement dans votre menu administrateur.',
            policy: {
                title: 'Politique de paiement',
                individual: 'Paiement individuel à la course',
                individualHint:
                    'Vos collaborateurs devront régler leurs réservations avec la carte bancaire ajoutée à leur profil personnel et définie comme moyen de paiement professionnel.',
                central: 'Paiement centralisé à la course',
                centralHint:
                    "Les réservations de vos collaborateurs seront réglées avec la carte bancaire définie à l'étape précédente.",
                nbParams: 'paramètre(s) actif(s)',
            },
        },
        company: {
            title: 'Informations sur la société',
            description: 'Ces informations sont requises afin de créer votre société',
            name: 'Nom de la société',
        },
        account: {
            title: 'Votre Compte',
            description: 'Ces informations sont nécessaires afin de finaliser votre compte LeCab',
            name: 'Nom du compte',
        },
        signContract: {
            title: 'Signature du contrat',
            description: 'Votre contrat signé vous sera envoyé par e-mail au format PDF.',
            cgu: "Le client déclare avoir pris connaissance des Conditions Générales d'Utilisation du service disponibles sur le site <a href='https://www.lecab.fr'>www.lecab.fr</a> et des conditions particulières ci-jointes.",
            sign: 'Signer',
        },
        welcome: {
            title: 'Bien débuter',
            creating: 'Création de l’espace client en cours...',
            videoTuto: 'Voir les tutoriels vidéos',
            invite: {
                radio: 'Invitez vos collaborateurs',
                description:
                    'Vous pouvez facilement invitez un ou plusieurs collaborateurs à rejoindre votre compte Entreprise afin de bénéficier des politiques voyages que vous définierez.',
            },
            policy: {
                radio: 'Modifier les politiques de voyage',
                description:
                    'Vous pouvez à tout moment modifier les politiques voyages de chacun de vos groupes, elles seront alors appliquées à chacun de vos collaborateurs du groupe.',
            },
        },
        layout: {
            stepZeroTitle: 'Votre offre',
            stepOneTitle: 'Votre compte',
            stepTwoTitle: 'Vos politiques voyages',
            stepThreeTitle: 'Vos moyens de paiement',
            stepFourTitle: 'Votre contrat',
            stepZeroTitleMobile: 'Offre',
            stepOneTitleMobile: 'Compte',
            stepTwoTitleMobile: 'Politiques voyages',
            stepThreeTitleMobile: 'Paiement',
            stepFourTitleMobile: 'Contrat',
        },
        shared: {
            skipStep: 'Définir plus tard ?',
            skipStepAction: 'Passez cette étape.',
            needHelp: 'Besoin d’aide ?',
            needHelpAction: 'Être appelé(e)',
        },
    },
    faq: {
        action: 'Envoyer',
        actionChange: 'Re-télécharger',
        description:
            "Pour tout problème sur l'une de vos réservations, nous vous invitons à suivre le lien “Obtenir de l’aide pour cette course” depuis votre",
        history: 'historique.',
        message: 'Ajouter un commentaire',
        booking_answer: 'Merci de vous rendre sur le lien suivant et de sélectionner la course en question',
        link_booking: 'Mes courses',
        files: {
            max: 'Maximum 1 fichier, max 10 Mo.',
            format_allowed: 'Formats autorisés : .jpg, .jpeg, .png, .gif, .pdf.',
            noFile: 'Aucun fichier détecté. Veuillez sélectionner un fichier.',
            tooHeavy: 'Le fichier fait plus de 10 Mo. Veuillez sélectionner un fichier de taille inférieure.',
            tooHeavyResized:
                'Après compression le fichier est toujours trop lourd. Veuillez sélectionner un fichier de taille inférieure.',
        },
        metas: {
            ride_reference: 'Numéro de course',
            invoice_reference: 'Numéro de facture',
            forgotten_object: 'Objet oublié',
            event_name: "Nom de l'événement",
            phone_number: 'Numéro de téléphone',
            company_name: 'Entreprise',
            week_number: 'Numéro de la semaine',
            partner_reference: 'ID du partenaire',
            manager_reference: 'ID du manager',
            driver_reference: 'ID du chauffeur',
            vehicle_reference: 'ID du véhicule',
        },
        actions: {
            confirm: {
                title: 'Demande envoyée !',
                message: 'Demande envoyée ! Nous reviendrons vers vous dans les meilleurs délais.',
                ok: 'Ok',
            },
        },
    },
    accessibility: {
        toggle: {
            changeToPro: 'Passer sur le compte pro',
            changeToPerso: 'Passer sur le compte perso',
        },
        invertPuDo: 'échanger le point de prise en charge et celui de la destination',
        hidden: 'élément caché',
        expand: 'ouvrir',
    },
    jo: {
        asap: 'Pour toute demande de course immédiate merci de contacter le numéro suivant : 09 86 86 07 16',
        schedule: 'Pour toute demande de course pour demain merci de contacter le numéro suivant : 09 86 86 07 16',
    },
    external: {
        popup: {
            title: 'Marcel devient LeCab',
            details: 'Vous utilisez actuellement l’application de transition “Marcel by LeCab”.',
            info: {
                b2c: {
                    title: '8€ offerts sur votre prochaine course LeCab 🎉',
                    details:
                        'Disponible sur l’application officielle LeCab. La réduction sera automatiquement ajoutée à votre compte.',
                },
                b2b: {
                    title: 'Téléchargez l’application LeCab',
                    details:
                        'Vous utilisez actuellement l’application de transition “Marcel by LeCab”. Téléchargez dès maintenant l’application officielle LeCab.',
                },
            },
            download: 'Télécharger LeCab',
        },
    },
    wicked: {
        title: 'Toutes les routes mènent au magicien avec LeCab !',
        description:
            "À l'occasion de la sortie au cinéma de WICKED PARTIE II, la magie s'invite chez LeCab ! Mais rassurez-vous, nos chauffeurs ne vous jetteront pas de sorts...",
        bulletGreenTitle: 'La gamme Green devient la gamme Green Wicked II',
        bulletGreenDescription: 'Son émission de Co2 est toujours aussi faible',
        bulletCoverTitle: 'Des voitures floquées',
        bulletCoverDescription:
            'Si vous avez de la chance, vous tomberez peut-être sur une voiture aux couleurs de WICKED PARTIE II',
        validate: "J'ai compris !",
    },
    onboarding: {
        step1: {
            title: 'Bienvenue chez LeCab !',
            action: 'Merci !',
        },
        step2: {
            title: 'Ajoutez une carte bancaire',
            info: 'Une demande sera envoyée à votre banque, mais aucun débit ne sera effectué.',
            action: 'Ajouter',
        },
        step3: {
            title: 'Activez votre géolocalisation',
            info: 'Activer votre géolocalisation vous permettra de réserver des courses plus facilement. LeCab ne garde aucune sauvegarde de vos déplacements.',
            action: 'Activer ma géolocalisation',
        },
        step4: {
            title: 'Activez les notifications',
            info: 'Activer les notifications vous permettra de recevoir vos informations de courses.',
            action: 'Activez les notifications',
        },
        step5: {
            title: 'Commandez votre première course',
            action: 'C’est parti !',
        },
    },
};
